import {Dictionary} from '../../types';
import {batchActions} from 'redux-batched-actions';
import {Item, itemStore} from '../entities/inventory/item';
import {Dispatch} from 'redux';
import {getInventoryManagementState} from '../../api/inventory/inventoryApi';
import {Order, orderStore} from '../entities/inventory/order';
import {Category, categoryStore} from '../entities/inventory/category';
import {Program, programStore} from '../entities/inventory/program';
import {House, houseStore} from '../entities/inventory/house';

export interface InventoryManagementState {
  items: Dictionary<Item>;
  orders: Dictionary<Order>;
  categories: Dictionary<Category>;
  programs: Dictionary<Program>;
  houses: Dictionary<House>;
}

export const loadInventoryManagementData = () => async (dispatch: Dispatch) => {
  const response: InventoryManagementState = await getInventoryManagementState();
  const sortedPrograms = Object.fromEntries(Object.entries(response.programs).sort(([, a], [, b]) => a.name.localeCompare(b.name)));
  const sortedHouses = Object.fromEntries(Object.entries(response.houses).sort(([, a], [, b]) => a.name.localeCompare(b.name)));
  await dispatch(batchActions([
    dispatch(itemStore.actions.set(response.items)),
    dispatch(orderStore.actions.set(response.orders)),
    dispatch(categoryStore.actions.set(response.categories)),
    dispatch(programStore.actions.set(sortedPrograms)),
    dispatch(houseStore.actions.set(sortedHouses))
  ], 'LOAD_INVENTORY_MANAGEMENT_STATE'));
};
